module.exports = __webpack_public_path__ + "static/img/gsjs_banner.4a56932.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gsjs_banner.png
// module id = yAXe
// module chunks = 0